import { AdminOverviewPage } from '@/features/admin/overview/overview-page'

export function OverviewPage() {
  return <AdminOverviewPage />
}
